
import {
  computed,
  defineComponent, onMounted, ref, Ref, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import AppHeader from '@/components/AppHeader.vue';
import {
  ICase, IMedia, IMixedData, IResponse,
} from '@/types/interfaces';
import DriveService from '@/modules/drive/services/DriveService';
import NotificationService from '@/services/NotificationService';
import MultipleSelectionPopUp from './BottomPopUp/PopUpTypes/MultipleSelectionPopUp.vue';
import MoveToPopUp from './BottomPopUp/PopUpTypes/MoveTo/MoveToPopUp.vue';
import SkeletonService from '@/services/SkeletonService';
import { MEDIA_TYPES, MIXED_DATA_TYPE } from '@/types/enums';
import AppQuestionPopUp from '@/components/AppQuestionPopUp.vue';

export default defineComponent({
  emits: ['close'],
  components: {
    AppHeader,
    MultipleSelectionPopUp,
    MoveToPopUp,
    AppQuestionPopUp,
  },
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const route = useRoute();

    const photos = computed<IMedia[]>(() => (driveStore.search ? driveStore.searchPhotos : driveStore.photos.data));
    const bigLoader: Ref<string> = ref('');

    const showMultiSelection = ref(false);
    const isMoveToPopUp = ref(false);

    const isPhotoSelected = computed(() => photos.value.filter((photo) => photo.selected).length);
    const isQuestionPopUp: Ref<boolean> = ref(false);

    function openQuestionPopUp() {
      showMultiSelection.value = false;
      isQuestionPopUp.value = true;
    }

    function deletePhotos() {
      // bigLoader.value = 'Deleting photos...';
      const selectedPhotoIds = photos.value.filter((photo) => photo.selected).map((photo) => photo.id);

      DriveService.deleteBatchFiles(selectedPhotoIds).then(() => {
      //   driveStore.photos = photos.value.filter((photo) => !photo.selected);
      //   driveStore.photoList = driveStore.photos;
      //   emit('close');
      //   NotificationService.notifySuccess();
      });
      // .then(() => { showMultiSelection.value = false; })
      // .finally(() => { bigLoader.value = ''; });

      showMultiSelection.value = false;
      const selected = photos.value.filter((photo) => photo.selected);
      driveStore.mixedData.data = driveStore.mixedData.data.filter((mix) => !selected.find((sel) => sel.id === mix.id));
      driveStore.photos.data = photos.value.filter((photo) => !photo.selected);
      driveStore.searchPhotos = driveStore.searchPhotos.filter((photo) => !photo.selected);
      driveStore.photoList = driveStore.photos.data;
      emit('close');
    }

    function setSkeletons(folderId: string | null, amount: number) {
      if (folderId) {
        SkeletonService.setFolderSkeletons(folderId, amount, MEDIA_TYPES.FILES);
      }
    }

    function removeSkeletons(folderId: string | null, amount: number) {
      if (folderId) {
        SkeletonService.removeFolderSkeletons(folderId, amount, MEDIA_TYPES.FILES);
      }
    }

    function toMixedData(selectedPhotos: IMedia[]): IMixedData[] {
      return selectedPhotos.map((selPhoto) => ({
        id: selPhoto.id!,
        type: MIXED_DATA_TYPE.FILE,
        file: selPhoto,
      }));
    }

    function syncData(folderId: string | null = null, selectedPhotos: IMedia[]) {
      if (folderId && driveStore.currentFolder?.id === folderId) {
        const hasItem = driveStore.currentFolder.mixedData?.find((mix) => mix.id === selectedPhotos[0].id);
        if (hasItem) {
          return;
        }
        const mixedData = toMixedData(selectedPhotos);
        driveStore.currentFolder.mixedData = [...mixedData, ...driveStore.currentFolder.mixedData!];
      }
    }

    function movePhotos(folderId: string | null = null) {
      // bigLoader.value = 'Moving photos...';
      const selectedPhotos = photos.value.filter((photo) => photo.selected);
      const selectedPhotoIds = selectedPhotos.map((photo) => photo.id);

      const promises: Promise<IResponse>[] = [];

      selectedPhotoIds.forEach((id) => {
        promises.push(DriveService.moveFile(id, folderId));
      });

      setSkeletons(folderId, selectedPhotoIds.length);
      Promise.all(promises)
        .then(() => {
          syncData(folderId, selectedPhotos);
          NotificationService.notifySuccess();
        })
        .finally(() => { removeSkeletons(folderId, selectedPhotoIds.length); });
      emit('close');
      showMultiSelection.value = false;
    }

    function openMoveToPopUp() {
      showMultiSelection.value = false;
      isMoveToPopUp.value = true;
    }

    watch(() => route.path, () => {
      driveStore.isPhotoSelector = false;
    });

    return {
      driveStore,
      bigLoader,
      isPhotoSelected,
      showMultiSelection,
      isMoveToPopUp,
      deletePhotos,
      isQuestionPopUp,
      openQuestionPopUp,
      openMoveToPopUp,
      movePhotos,
    };
  },
});
